import {
  Container,
  Stack,
  Box,
  Text,
  HStack,
  Divider,
  SimpleGrid,
  Tag,
  Wrap,
  WrapItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import t from "../translations";

const MotionBox = motion(Box);

function SkillCategory({ category, index, color }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const cardBg = useColorModeValue("gray.50", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");

  return (
    <MotionBox
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.45, delay: index * 0.1, ease: "easeOut" }}
    >
      <Box
        bg={cardBg}
        p={{ base: 4, md: 6 }}
        borderRadius="xl"
        borderWidth="1px"
        borderColor={borderColor}
        h="100%"
      >
        <Text
          fontWeight={600}
          fontSize="sm"
          color={`${color}.400`}
          mb={4}
          textTransform="uppercase"
          letterSpacing="wider"
        >
          {category.title}
        </Text>
        <Wrap spacing={2}>
          {category.items.map((skill) => (
            <WrapItem key={skill}>
              <Tag
                size="md"
                variant="subtle"
                colorScheme={color}
                borderRadius="full"
              >
                {skill}
              </Tag>
            </WrapItem>
          ))}
        </Wrap>
      </Box>
    </MotionBox>
  );
}

export default function Skills({ color }) {
  return (
    <Container maxW="4xl" id="skills" py={{ base: 16, md: 24 }}>
      <Stack spacing={{ base: 8, md: 10 }}>
        <Stack align="center" direction="row" px={4}>
          <HStack mx={4}>
            <Text fontWeight={800} fontSize={{ base: "xl", md: "2xl" }} whiteSpace="nowrap">
              {t.skills.heading}
            </Text>
          </HStack>
          <Divider />
        </Stack>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} px={4}>
          {t.skills.categories.map((cat, i) => (
            <SkillCategory
              key={cat.title}
              category={cat}
              index={i}
              color={color}
            />
          ))}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
